import axios from 'axios'
import { Message } from 'iview'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

export function downFile(url, req) {
  axios.get(url, {
    params: req,
    crossDomain: true,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'YJHTOKEN': localStorage.getItem('token')
    },
    responseType: 'blob'
  }).then(res => {
    if (res.status !== 200) {
      Message.info('导出数据失败')
      return
    }
    const string = res.headers['content-disposition']
    if (string === undefined || string === null) {
      Message.info('文件出错')
      return
    }
    const demoName = string.split(';').pop().slice(18)
    var blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = decodeURI(demoName)
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(href)
  })
}
export function downImg(url, name) {
  if (!url) {
    return false
  }
  url += '?t=' + new Date().getTime()
  axios.get(url, {
    responseType: 'blob'
  }).then(res => {
    if (res.status !== 200) {
      Message.info('导出数据失败')
      return
    }
    var blob = new Blob([res.data], {
      type: 'image/jpg'
    })
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = name
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(href)
  })
}

export function downloadPdf($dom, fileName = '导出') {
  window.scrollTo(0, 0)
  html2canvas($dom, {
    scale: 1,
    useCORS: true,
    backgroundColor: '#fff',
    allowTaint: true
    // width: $dom.scrollWidth
  }).then(canvas => {
    var contentWidth = canvas.width
    var contentHeight = canvas.height
    // 一页pdf显示html页面生成的canvas高度;
    // var pageHeight = contentWidth / 592.28 * 841.89
    var pageHeight = contentWidth / 592.28 * 841.89
    // 未生成pdf的html页面高度
    var leftHeight = contentHeight
    // pdf页面偏移
    // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = 592.28 / contentWidth * contentHeight
    var pageData = canvas.toDataURL('image/jpeg', 2.0)
    // eslint-disable-next-line
    var position = 0
    var pdf = new JsPDF('', 'pt', 'a4')
    // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > 0) {
        pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= 841.89
        // 避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage()
        }
      }
    }
    pdf.save(fileName + '.pdf')
    // 导出pdf文件命名
  })
}